import React, { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { PageHero } from '../../../components/pageHero/PageHero';
import { endpoints } from 'endpoints.config';
import { InfoTable } from 'components/infoTable/infoTable';
import { Spinner } from 'components/spinner/Spinner';
import { WondeApi } from 'api/wondeApi';
import { useToast } from 'hooks/useToast';
import { PreviouslyMatchedRecords } from '../wIFeatures/PreviouslyMatchedRecords';

type WIStep1Props = {
  setCurrentStep: Dispatch<SetStateAction<number>>;
  setWondeIntegration: Dispatch<SetStateAction<boolean>>;
  currentSynOpt: string;
};

export const WIStep1: React.FC<WIStep1Props> = ({ 
  setCurrentStep, 
  setWondeIntegration,
  currentSynOpt,
}) => {
  const [checkTableLoading, setCheckTableLoading] = useState<any>(false);
  const [listUrl, setListUrl] = useState<string>("");
  const [submitUrl, setSubmitUrl] = useState<string>("");
  const [pageName, setPageName] = useState<string | null>(null);
  const [isPanelClosed, setIsPanelClosed] = useState<boolean>(true);
  const [matchesSelected, setMatchesSelected] = useState<any>([]);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [tableData, setTableData] = useState<any>([]);
  const [endpointTableErr, setEndpointTableErr] = useState<boolean>(false);

  const successToast = useToast("Successfully submitted");

  useEffect(() => {
    document.body.style.overflowY = '';
  }, []);  

  useEffect(() => {
    if(currentSynOpt){
      loadData();
    }
  }, [currentSynOpt]);

  useEffect(() => {
    if(endpointTableErr){
      setCurrentStep(2);
    }
  }, [endpointTableErr]);  

  const loadData = async () => {
    setPageName(`Sync ${currentSynOpt} Records`);

    const currentListUrl = currentSynOpt === "Class" ?
      endpoints.wondeIntegration.classStep1List :
      endpoints.wondeIntegration.pupilStep1List;

    setListUrl(currentListUrl);

    const currentSubmitUrl = currentSynOpt === "Class" ?
      endpoints.wondeIntegration.classStep1NameMatch :
      endpoints.wondeIntegration.pupilStep1NameMatch;

    setSubmitUrl(currentSubmitUrl);
  };

  const submitMatchOpts = async () => {
    setIsSubmitting(true);

    const selectedIds = matchesSelected.map((item: any) => {
      return currentSynOpt === "Class" ?
        { "classID": item.classes__id, "wondeClassID": item.wondeclasses__id } :
        currentSynOpt === "Pupil" ?
        { "pupilID": item.pupils__id, "wondePupilID": item.wondepupils__id } :
        { "schoolUserID": item.schoolusers__id, "wondeSchoolUserID": item.wondeSchoolusers__id }
    });

    if(selectedIds.length > 0){
      const result = await WondeApi.submitSelectedWondeExactMatches(selectedIds, submitUrl);

      if (!result.error) {
        successToast();
        window.scrollTo(0, 0);
        setCurrentStep(2);
      }
      
      if (result.error) {
        setError("An error occurred, please try again.");
        setIsSubmitting(false);
      }
    } else {
      window.scrollTo(0, 0);
      setCurrentStep(2);
    }
  };

  return (
    <div className={"PageContent WondeIntegrationPage Step1 " + currentSynOpt}>
      <PageHero title={pageName ?? ''} />
      <div className="WidthContent">
        {checkTableLoading &&
          <div className="LoadingPanel">
            <div className="LPInfo">
              <Spinner />
              <div className="LPTxt">Hang tight...we are just checking your data!</div>
            </div>
          </div>
        }

        {isSubmitting &&
          <div className="WILoadingPanel">
            <Spinner color={'#f59e16'} />
          </div>
        }

        <div className="TopInfoRow">
          <div className="LeftSide">
            <h2>Exact Matches</h2>
          </div>
          <div className="RightSide">
            {/*<p>Step 1 of 4</p>*/}
          </div>
        </div>
        <p>Here are exact matches we have identified between your Wonde and Get Set records. {currentSynOpt === "Pupil" ? "Match the Wonde records with your Get Set records." : "Select the Wonde records that match your Get Set records and confirm."}</p>

        {error &&
          <div className="ErrorTxt">{error}</div>
        }

        {listUrl &&
          <InfoTable
            listUrl={listUrl}
            firstColWidth={215}
            firstColWidthSm={110}
            updateListStatus={true}
            setIsPanelClosed={setIsPanelClosed}
            isPanelClosed={isPanelClosed}
            allowSelectAll={true}
            filterTable={false}
            setCheckTableLoading={setCheckTableLoading}
            hideSideMenu={true}
            getSelectedOpts={{ 
              "getOpts": setMatchesSelected, 
              "id": currentSynOpt === "Class" ? 
                "classes__id" :
                currentSynOpt === "Pupil" ?
                "pupils__id" :
                "schoolusers__id"
            }}
            rowHighlight={true}
            wondeRow={true}
            wondeRowType={currentSynOpt}
            hideBtmCtrls={true}
            setTableData={setTableData}
            endpointTableErr={setEndpointTableErr}
          >
          </InfoTable>
        }

        <PreviouslyMatchedRecords currentSynOpt={currentSynOpt} />

        <div className="BtmBtns">
          <div className="Btn BtnWhite LeftBtn" onClick={() => {
            window.scrollTo(0, 0);
            setWondeIntegration(false);
          }}>Cancel</div>
          {!checkTableLoading &&
            <div className="Btn BtnOrange RightBtn" onClick={() => submitMatchOpts()}>Confirm</div>
          }
        </div>
      </div>
    </div>
  );
};